import { ComponentProps } from 'react'

import { joinStyles } from 'app/utils/theme'

import * as styles from './index.css'

type FlexProperties = ComponentProps<'div'> & {
    column?: boolean
}

export const Flex = ({
    className,
    column,
    ...properties
}: Readonly<FlexProperties>): JSX.Element => {
    return (
        <div
            className={joinStyles(
                styles.root,
                column && styles.column,
                className,
            )}
            {...properties}
        />
    )
}
